// Translations FR / EN — Bac à jeux
// FR is default. To add a key: add it in both fr and en blocks.

export const translations = {
  fr: {
    nav: {
      mission: "Notre mission",
      universes: "Univers",
      followMe: "Follow Me",
      founders: "Fondateurs",
      upcoming: "À venir",
      cta: "Suivre l'aventure",
    },
    hero: {
      badge: "Premier jeu en approche — campagne Ulule à venir",
      title1: "Des jeux qui mettent",
      title2: "le bazar",
      title3: "autour de la table.",
      subtitle:
        "Maison d'édition de jeux de société à Poissy, imaginée par des passionnés pour celles et ceux qui aiment rire, jouer, trahir un peu… et recommencer.",
      cta1: "Suivre l'aventure",
      cta2: "Découvrir Follow Me",
    },
    mission: {
      kicker: "Notre mission",
      title: "Créer des jeux qui font parler la table",
      text: "Chez Bac à jeux, on aime les jeux qui déclenchent quelque chose : un fou rire, un regard suspicieux, une alliance improbable, une petite trahison bien sentie ou une revanche immédiate. Notre envie est simple : éditer des jeux accessibles, vivants et mémorables, capables de réunir les joueurs autour d'un vrai moment.",
      values: [
        {
          title: "Ambiance",
          text: "Des jeux qui créent de l'interaction, du rythme et des souvenirs.",
        },
        {
          title: "Audace",
          text: "Des mécaniques qui osent les coups fourrés, les surprises et les retournements.",
        },
        {
          title: "Accessibilité",
          text: "Des règles claires, une prise en main rapide, du plaisir dès la première partie.",
        },
      ],
    },
    universes: {
      kicker: "Nos univers de jeux",
      adults: {
        tag: "Adultes & grands ados",
        title: "Pour les grands : l'ambiance, la vraie",
        text: "Des jeux de table où l'on négocie, bluffe, provoque, accuse, rit, se venge et recommence. Des jeux pensés pour les soirées entre amis, les familles joueuses, les apéros, les festivals et toutes les tables qui aiment quand ça bouge.",
      },
      kids: {
        tag: "Enfants & familles",
        title: "Pour les plus jeunes : le plaisir avant tout",
        text: "Des jeux pour enfants et familles, construits autour de l'amusement, de la découverte et du plaisir immédiat. Des expériences simples à comprendre, joyeuses à jouer, et suffisamment malignes pour donner envie d'y revenir.",
      },
    },
    followMe: {
      kicker: "Le premier jeu",
      title1: "Follow Me",
      title2: "arrive bientôt",
      text: "Follow Me sera le premier grand projet porté par Bac à jeux. Un jeu d'ambiance moderne, coloré, interactif, pensé pour provoquer des discussions, des stratégies opportunistes, des coups bas assumés et beaucoup de bruit autour de la table.",
      note: "Campagne Ulule en préparation. Restez dans les parages : les premières infos arrivent très bientôt.",
      ctaNotify: "Être prévenu du lancement",
      newsletter: {
        title: "Ne ratez pas le lancement",
        sub: "Follow Me arrive bientôt sur Ulule. Laissez-nous une petite place dans vos favoris, on prépare la suite.",
        placeholder: "votre.email@exemple.com",
        button: "Me prévenir",
        success: "Merci ! On vous écrit dès qu'on a du neuf.",
        invalid: "Hmm, cette adresse n'a pas l'air valide.",
      },
      stats: [
        { value: "3-6", label: "joueurs" },
        { value: "20'", label: "par partie" },
        { value: "14+", label: "à partir de" },
      ],
      gallery: {
        kicker: "Aperçu",
        title1: "Un avant-goût des",
        title2: "cartes",
        sub: "Quelques cartes de Follow Me déjà sorties du bac. Bonus, sponsors, coups bas et achats : à toi de doser la combine.",
      },
      box: {
        kicker: "La boîte",
        title1: "La boîte qui pose",
        title2: "le décor",
        text: "Une identité graphique très pop, inspirée des réseaux sociaux : dégradés vifs, silhouettes colorées, et un ton qui annonce la couleur dès le couvercle. Recto pour donner envie, verso pour donner les règles du jeu.",
        recto: "Recto — la couverture",
        verso: "Verso — comment on joue",
        frontBadge: "Recto",
        backBadge: "Verso",
        points: [
          {
            title: "Format compact",
            sub: "64 cartes, une boîte qui se glisse partout — apéro, vacances, festivals.",
          },
          {
            title: "Identité réseau social",
            sub: "Dégradés orange/rose/violet/bleu, ambiance feed assumée.",
          },
          {
            title: "2 à 5 joueurs · 14+",
            sub: "Une partie en 15 minutes chrono. Le temps d'un scroll.",
          },
        ],
      },
    },
    founders: {
      kicker: "Qui sommes-nous ?",
      title: "Deux Pisciacais tombés dans le jeu",
      intro:
        "Bac à jeux, c'est d'abord l'histoire de deux passionnés de jeux de société, Pisciacais, qui ont décidé de passer de l'autre côté de la table : imaginer, développer et éditer les jeux qu'ils avaient envie de voir exister.",
      benjamin: {
        name: "Benjamin Attal",
        role: "Co-fondateur — Univers ludiques & narration",
        bio: "Benjamin Attal est un fervent admirateur des jeux de société, des jeux de rôle et des jeux pour enfants. Il aime les univers ludiques qui racontent quelque chose, les mécaniques accessibles mais malignes, et les jeux capables de créer des moments sincères entre les joueurs.",
      },
      christophe: {
        name: "Christophe Begin",
        role: "Co-fondateur — Expertise ludique & œil critique",
        bio: "Christophe Begin connaît le jeu de société par le terrain. Ancien ludicaire et gérant d'une boutique de jeux pendant sept ans, il a conseillé, vendu, expliqué et transmis des centaines de jeux avant de passer le flambeau à une nouvelle génération. Son regard est celui d'un passionné qui connaît les joueurs, les tables et les vraies attentes du public.",
      },
      closing:
        "Ensemble, Benjamin et Christophe veulent oser ce que l'on n'ose pas toujours dans le jeu de société : des propositions franches, vivantes, parfois un peu piquantes, mais toujours pensées pour le plaisir des joueurs.",
    },
    manifesto: {
      kicker: "Pourquoi Bac à jeux ?",
      title1: "On aime les jeux qui",
      title2: "débordent",
      title3: "du plateau",
      text: "Un bon jeu ne s'arrête pas à ses règles. Il continue dans les discussions, dans les souvenirs, dans les « on en refait une ? », dans les petites rancunes de bonne foi et les grands éclats de rire. Bac à jeux veut éditer des jeux qui laissent une trace, qui donnent envie de se réunir, et qui transforment une simple partie en moment partagé.",
    },
    upcoming: {
      kicker: "À venir",
      title: "Les prochains projets sont déjà dans la boîte",
      text: "Follow Me ouvre la voie, mais Bac à jeux prépare déjà d'autres idées : des jeux d'ambiance, des jeux pour enfants, des formats familiaux et des expériences pensées pour faire jouer le plus grand nombre.",
      cards: [
        { tag: "Prototype", title: "Projet en développement", sub: "Jeu d'ambiance — adultes" },
        { tag: "Prototype", title: "Projet en développement", sub: "Format familial" },
        { tag: "Prototype", title: "Projet en développement", sub: "Jeu pour enfants" },
      ],
    },
    finalCta: {
      title: "Prêt à suivre Bac à jeux ?",
      text: "Le premier lancement approche. Suivez la page, gardez un œil sur Follow Me, et préparez-vous à découvrir une nouvelle maison d'édition qui aime quand la table s'anime.",
      cta1: "Suivre l'aventure",
      cta2: "Découvrir Follow Me",
      cta3: "Contact",
    },
    footer: {
      tagline: "Maison d'édition de jeux de société",
      city: "Poissy, France",
      contact: "Contact",
      contactValue: "Écrivez-nous",
      social: "Réseaux sociaux",
      socialValue: "à compléter",
      rights: "Tous droits réservés",
    },
    contact: {
      title: "Nous écrire",
      sub: "Une question, une remarque, une envie de collaboration ? Laissez-nous un mot, on répond rapidement.",
      submit: "Envoyer",
      sending: "Envoi…",
      success: "Message bien reçu ! On revient vers vous très vite.",
      privacy:
        "Vos infos restent chez nous, point. On vous répond, on n'en fait rien d'autre.",
      fields: {
        name: "Votre nom",
        namePlaceholder: "Prénom Nom",
        email: "Votre email",
        emailPlaceholder: "vous@exemple.com",
        subject: "Sujet",
        subjectPlaceholder: "Une partie, une presse, un projet…",
        message: "Votre message",
        messagePlaceholder: "Dites-nous tout, on adore.",
      },
      errors: {
        name: "Pensez à indiquer votre nom.",
        email: "Cet email ne semble pas valide.",
        message: "Votre message est un peu court — quelques mots de plus ?",
        generic: "Oups, l'envoi n'a pas pu aboutir. Réessayez dans un instant ?",
        notConfigured: "Le formulaire n'est pas encore configuré. Réessayez bientôt.",
      },
    },
  },
  en: {
    nav: {
      mission: "Mission",
      universes: "Universes",
      followMe: "Follow Me",
      founders: "Founders",
      upcoming: "Coming up",
      cta: "Follow the journey",
    },
    hero: {
      badge: "First game incoming — Ulule campaign on its way",
      title1: "Games that turn",
      title2: "the table",
      title3: "upside down.",
      subtitle:
        "A board game publisher from Poissy, France, dreamed up by passionate folks for everyone who loves laughing, playing, betraying a little… and going again.",
      cta1: "Follow the journey",
      cta2: "Discover Follow Me",
    },
    mission: {
      kicker: "Our mission",
      title: "Make games that get the table talking",
      text: "At Bac à jeux, we love games that spark something: a burst of laughter, a suspicious glance, an unlikely alliance, a well-timed betrayal or an instant payback. Our goal is simple: publish accessible, lively and memorable games that bring players together for a real moment.",
      values: [
        {
          title: "Vibe",
          text: "Games that create interaction, rhythm and lasting memories.",
        },
        {
          title: "Boldness",
          text: "Mechanics that dare to dive into mischief, surprises and plot twists.",
        },
        {
          title: "Accessibility",
          text: "Clear rules, quick to learn, fun from the very first game.",
        },
      ],
    },
    universes: {
      kicker: "Our game universes",
      adults: {
        tag: "Adults & teens",
        title: "For the grown-ups: real, loud vibes",
        text: "Table games where you negotiate, bluff, taunt, accuse, laugh, get revenge and start over. Built for game nights, playful families, after-work drinks, festivals and any table that loves a bit of chaos.",
      },
      kids: {
        tag: "Kids & families",
        title: "For the young ones: fun above all",
        text: "Games for kids and families built around fun, discovery and instant joy. Easy to understand, joyful to play, and clever enough to make you want one more round.",
      },
    },
    followMe: {
      kicker: "First game",
      title1: "Follow Me",
      title2: "is coming",
      text: "Follow Me will be the first big project from Bac à jeux. A modern, colorful and interactive party game built to fuel debates, opportunistic strategies, fully embraced low blows and lots of noise around the table.",
      note: "Ulule campaign in preparation. Stick around — first reveals are coming very soon.",
      ctaNotify: "Notify me at launch",
      newsletter: {
        title: "Don't miss the launch",
        sub: "Follow Me is coming soon on Ulule. Save us a little spot in your favorites — the rest is on its way.",
        placeholder: "your.email@example.com",
        button: "Notify me",
        success: "Thanks! We'll write the moment we have news.",
        invalid: "Hmm, that email doesn't look quite right.",
      },
      stats: [
        { value: "3-6", label: "players" },
        { value: "20'", label: "per game" },
        { value: "14+", label: "age" },
      ],
      gallery: {
        kicker: "Sneak peek",
        title1: "A first look at the",
        title2: "cards",
        sub: "A few Follow Me cards already out of the box. Bonuses, sponsors, dirty tricks and buys — your call on how to mix the combo.",
      },
      box: {
        kicker: "The box",
        title1: "The box that sets",
        title2: "the mood",
        text: "A very pop visual identity, inspired by social media: vibrant gradients, colorful silhouettes, and a tone that sets things off from the cover. Front to make you want it, back to tell you how to play.",
        recto: "Front — the cover",
        verso: "Back — how to play",
        frontBadge: "Front",
        backBadge: "Back",
        points: [
          {
            title: "Compact size",
            sub: "64 cards, a box that fits anywhere — drinks, holidays, festivals.",
          },
          {
            title: "Social-feed identity",
            sub: "Orange/pink/purple/blue gradients, full feed vibe.",
          },
          {
            title: "2 to 5 players · 14+",
            sub: "A round in 15 minutes flat. About the time of a scroll.",
          },
        ],
      },
    },
    founders: {
      kicker: "Who we are",
      title: "Two Pisciacais who fell into games",
      intro:
        "Bac à jeux is first and foremost the story of two board-game enthusiasts from Poissy who decided to switch sides of the table: to imagine, develop and publish the games they wanted to see exist.",
      benjamin: {
        name: "Benjamin Attal",
        role: "Co-founder — Worlds & storytelling",
        bio: "Benjamin Attal is a devoted fan of board games, role-playing games and games for kids. He loves worlds that tell a story, mechanics that are accessible but clever, and games that create sincere moments between players.",
      },
      christophe: {
        name: "Christophe Begin",
        role: "Co-founder — Game expertise & critical eye",
        bio: "Christophe Begin knows board games from the ground up. A former board-game retailer and game shop owner for seven years, he has recommended, sold, explained and passed on hundreds of games before handing the torch to a new generation. His eye is that of a passionate player who knows the tables and what they really want.",
      },
      closing:
        "Together, Benjamin and Christophe want to dare what board games don't always dare: honest, lively, sometimes a bit cheeky proposals — always made for the players' pleasure.",
    },
    manifesto: {
      kicker: "Why Bac à jeux?",
      title1: "We love games that",
      title2: "spill over",
      title3: "the board",
      text: "A good game doesn't stop at its rules. It carries on in the conversations, in the memories, in the « one more round? », in the little playful grudges and the big laughs. Bac à jeux wants to publish games that leave a trace, that make you want to get together, and that turn a simple game night into a shared moment.",
    },
    upcoming: {
      kicker: "Coming up",
      title: "Other projects are already in the box",
      text: "Follow Me opens the way, but Bac à jeux is already cooking up more: party games, kids' games, family formats and experiences designed for the widest range of players.",
      cards: [
        { tag: "Prototype", title: "Project in development", sub: "Party game — adults" },
        { tag: "Prototype", title: "Project in development", sub: "Family format" },
        { tag: "Prototype", title: "Project in development", sub: "Kids' game" },
      ],
    },
    finalCta: {
      title: "Ready to follow Bac à jeux?",
      text: "The first launch is around the corner. Follow the page, keep an eye on Follow Me, and get ready to discover a new publisher that loves when the table comes alive.",
      cta1: "Follow the journey",
      cta2: "Discover Follow Me",
      cta3: "Contact",
    },
    footer: {
      tagline: "Board game publisher",
      city: "Poissy, France",
      contact: "Contact",
      contactValue: "Write to us",
      social: "Socials",
      socialValue: "coming soon",
      rights: "All rights reserved",
    },
    contact: {
      title: "Get in touch",
      sub: "A question, a remark, a collab idea? Drop us a word — we reply fast.",
      submit: "Send",
      sending: "Sending…",
      success: "Message received! We'll get back to you very soon.",
      privacy:
        "Your info stays with us. We answer you, and that's it.",
      fields: {
        name: "Your name",
        namePlaceholder: "First Last",
        email: "Your email",
        emailPlaceholder: "you@example.com",
        subject: "Subject",
        subjectPlaceholder: "A game session, press, a project…",
        message: "Your message",
        messagePlaceholder: "Tell us everything, we love it.",
      },
      errors: {
        name: "Don't forget to share your name.",
        email: "This email doesn't look valid.",
        message: "Your message is a bit short — a few more words?",
        generic: "Oops, couldn't send. Try again in a moment?",
        notConfigured: "The contact form isn't configured yet. Please try again soon.",
      },
    },
  },
};
